import { Component, input } from '@angular/core';

import { MovieDetailSkeletonComponent } from '@usheru-hff/ui/movie-detail-page';

/**
 * This could be used in any other component to display a rating.
 */

@Component({
  selector: 'ush-movie-rating',
  standalone: true,
  imports: [MovieDetailSkeletonComponent],
  template: `
    @if (isLoadingData()) {
      <div class="review-rating review-rating--loading">
        @for (star of numToArray(rating() || 3); track star) {
          <ush-movie-detail-skeleton width="1rem" height="1rem" radius="999px"></ush-movie-detail-skeleton>
        }
      </div>
    } @else if (rating()) {
      <div class="review-rating">
        @for (star of numToArray(rating()); track star) {
          <i class="pi pi-star-fill" style="font-size: {{ size() }}rem;"></i>
        }
      </div>
    }
  `,
  styles: `
    .review-rating {
      display: var(--review-rating-display, inline-flex);
      column-gap: var(--review-rating-gap, 6px);
      * {
        color: var(--review-rating-color, var(--textColor));
      }
    }
  `
})
export class MovieRatingComponent {
  rating = input<number>();
  size = input<number>(1);
  isLoadingData = input(false);

  numToArray(num: number) {
    return new Array(num);
  }
}
